import {
  GET_REGISTERED_NODES_FULFILLED,
  SELECT_REGISTERED_NODE,
  GET_REGISTERED_NODE_PENDING,
  GET_REGISTERED_NODE_FULFILLED,
  RegisteredNodeActionTypes,
  RegisteredNodeState,
} from './registeredNode.types';
import { adaptRegisteredNodeList, adaptSelectedRegisteredNode, adaptFromServerFormat } from './registeredNode.adapter';

const initialState: RegisteredNodeState = {
  entities: [],
  select: [],
  single: null,
};

export default function registeredNodeReducer(
  state = initialState,
  action: RegisteredNodeActionTypes,
): RegisteredNodeState {
  switch (action.type) {
    case GET_REGISTERED_NODES_FULFILLED:
      return { ...state, entities: adaptRegisteredNodeList(action.payload.data.data || []) };

    case SELECT_REGISTERED_NODE:
      return { ...state, select: adaptSelectedRegisteredNode(action.payload || []) };

    case GET_REGISTERED_NODE_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_REGISTERED_NODE_FULFILLED:
      return {
        ...state,
        single: adaptFromServerFormat((action.payload.data.data ?? [])[0]),
      };

    default:
      return state;
  }
}
